<template>
	<div class="add-qcm-container">
		<GenerateQCM :isSuperAdmin="true" />
	</div>
</template>

<script>
// import AIGeneratedQCMQuestion from "../../Admin/Search/QCM/AIGeneratedQCMQuestion.vue";
import GenerateQCM from "../../Admin/Search/QCM/GenerateQCM.vue";
export default {
	components: {
		GenerateQCM
	}
};
</script>
